exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".listlink{margin-bottom:1em}.listlink:hover{cursor:pointer;color:#0c7cd5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2dda5de8!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/app/bdefiles/BdefilesIndex.vue
// module id = 953
// module chunks = 0